<template>
  <ngc-modal
    :open="showModal"
    variant="decide"
    :title.prop="title"
    data-testid="failed-upload-docs-modal"
    @close="handleClose"
  >
    <div class="mb-10">
      {{ message }}
    </div>

    <div
      v-for="(fileName, i) in fileNames"
      :key="i"
    >
      {{ fileName }}
    </div>

    <!-- ngc-modal's decide footer hardcodes "Cancel"; filling the slot lets us label both buttons. -->
    <div
      slot="footer"
      class="failed-upload-docs-actions"
    >
      <ngc-button
        variant="secondary"
        start-icon="copy"
        @click="handleCopy"
      >
        Copy Text
      </ngc-button>
      <ngc-button
        variant="primary"
        @click="handleClose"
      >
        Close
      </ngc-button>
    </div>
  </ngc-modal>
</template>

<script>

export default {
  name: 'FailedUploadDocsModal',
  props: {
    toggleModal: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    fileNames: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showModal: false
    }
  },
  watch: {
    toggleModal () {
      this.showModal = this.toggleModal
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    handleCopy () {
      const txt = this.fileNames.join('\n')
      navigator.clipboard.writeText(txt)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>

/* Mirrors Gator's .gator-modal-action-buttons so the slotted footer keeps stock spacing. */
.failed-upload-docs-actions {
  display: flex;
  gap: var(--spacing-5);
  margin-left: auto;
}

@media (max-width: 600px) {
  .failed-upload-docs-actions {
    flex-direction: column-reverse;
    width: 100%;
    margin-left: 0;
  }

  .failed-upload-docs-actions ngc-button {
    --ngc-button-width: 100%;
  }
}

</style>
